// extracted by mini-css-extract-plugin
export default {"primary":"#b3b3b3","textColor":"#d8d8d8","secondary":"#e98074","whitespace":"#0b0b0d"};